import { ENUM__debug_feature_client } from '@/_debug/ENUM__debug_feature_client';
import { AnimationCellGradientBlink } from '@/components/ui/animation_cell_gradient_blink';
import { HOOK_GRID2D_CELL__icon_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__icon_size';
import React, { useMemo } from 'react';
import { GRID2D_CELL__placeholder } from './GRID2D_CELL__placeholder';

interface PROPS {
  width: number;
  height: number;
  column_index: number;
}

export const GRID2D_CELL__generation_waiting = React.memo(({ width, height, column_index }: PROPS) => {
  const background_color = '#404040';
  const foreground_color = '#737373';

  /*
   * STATE
   */
  const { icon_width, icon_height } = HOOK_GRID2D_CELL__icon_size(width, height);
  const icon_side_min = Math.min(icon_width, icon_height);

  const borderGradientRatio = 2;
  let duration = 4;
  let pause = 3;

  const begin = column_index * 0.2 + pause;

  const icon_gradient_ratio = useMemo(() => {
    const scaleFactor = Math.max(width, height) / icon_side_min;
    return borderGradientRatio * scaleFactor;
  }, [width, height, icon_side_min, borderGradientRatio]);

  /*
   * HTML
   */
  if (!ENUM__debug_feature_client.ENABLE_ANIMATION_GRADIENT_BLINK) return <GRID2D_CELL__placeholder {...{ width, height }} />;

  return (
    <div className="relative flex justify-center items-center bg-transparent rounded-2xl" style={{ width, height }}>
      <AnimationCellGradientBlink
        unique_key={column_index + 'loder-cell'}
        className="absolute top-0 left-0 w-full h-full z-10 pointer-events-none"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        gradientRatio={borderGradientRatio}
        {...{ background_color, foreground_color, duration, column_index, begin }}
      >
        <rect x="0" y="0" width={width} height={height} rx="16" ry="16" fill="transparent" stroke="url(#borderGradient)" strokeWidth="2" />
      </AnimationCellGradientBlink>

      <div className="absolute z-20 inset-[1px] bg-component rounded-xl" />

      <div className="z-30 relative flex justify-center items-center">
        <AnimationCellGradientBlink
          unique_key={column_index + 'loder-cell-icon'}
          width={icon_side_min}
          height={icon_side_min}
          viewBox="0 0 512 512"
          gradientRatio={icon_gradient_ratio}
          {...{ background_color, foreground_color, duration, column_index, begin }}
        >
          <path d="M 0 96 c 0 -35.3 28.7 -64 64 -64 h 384 c 35.3 0 64 28.7 64 64 v 320 c 0 35.3 -28.7 64 -64 64 H 64 c -35.3 0 -64 -28.7 -64 -64 V 96 z m 323.8 106.5 c -4.5 -6.6 -11.9 -10.5 -19.8 -10.5 s -15.4 3.9 -19.8 10.5 l -87 127.6 l -26.5 -33.1 c -4.6 -5.7 -11.5 -9 -18.7 -9 s -14.2 3.3 -18.7 9 l -64 80 c -5.8 7.2 -6.9 17.1 -2.9 25.4 S 78.8 416 88 416 h 336 c 8.9 0 17.1 -4.9 21.2 -12.8 s 3.6 -17.4 -1.4 -24.7 l -120 -176 z" />
          <circle cx="112" cy="144" r="48" />
        </AnimationCellGradientBlink>
      </div>
    </div>
  );
});
